<div [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize  : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group">
  <mat-checkbox [formControlName]="field.name" [matTooltip]="field.hint" [matTooltipDisabled]="!field.hint"
    matTooltipPosition="above" matTooltipClass="sbm-tooltip" color="primary">
    <app-required *ngIf="isRequired()"></app-required>
    <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
    {{field.label}}
  </mat-checkbox>
  <mat-error *ngIf="group.get(field.name).touched && group.get(field.name).hasError('required')">
    Please check this.
  </mat-error>
</div>
